import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import Arrow from "./Arrow";
import Generalsidebar from "./Generalsidebar";

const ALLTHERAPISTURL = "https://thrive-mqy3.onrender.com/v1/therapists";
const accessToken = localStorage.getItem("accessToken");

function Maintherapy() {
  // const [therapists, setTherapists] = useState([]);
  const [therapists, setTherapists] = useState([]);
  useEffect(() => {
    console.log(accessToken);
    const userDetail = {
      method: "GET",

      headers: { Authorization: `Bearer ${accessToken}` },
    };
    fetch(ALLTHERAPISTURL, userDetail)
      .then((response) => response.json())

      .then((data) => {
        console.log("allTherapist", data);
        if (data.message == "Please authenticate") {
          return;
        }
        setTherapists(data);
      });
  }, []);
  const allTherapists = therapists;
  const [showSidebar, setShowSidebar] = useState(false);

  function handleArrowClick() {
    setShowSidebar(true);
  }
  const [name, setName] = useState("");
  const [state, setState] = useState("");
  const [specialty, setSpecialty] = useState("");
  const navigate = useNavigate();

  function searchbyName(e) {
    const currentTherapists = allTherapists.filter(
      (therapist) =>
        therapist.user.firstName
          .toLowerCase()
          .trim()
          .slice(0, e.target.value.length) ==
          e.target.value.toLowerCase().trim() ||
        therapist.user.lastName
          .toLowerCase()
          .trim()
          .slice(0, e.target.value.length) ==
          e.target.value.toLowerCase().trim()
    );
    console.log(currentTherapists);
    setTherapists(currentTherapists);
  }

  function searchbyState(e) {
    // setName(e.target.value);
    const currentTherapists = allTherapists
      .filter((therapist) => therapist.location != null)
      .filter(
        (therapist) =>
          therapist.location
            .toLowerCase()
            .trim()
            .slice(0, e.target.value.length) ===
          e.target.value?.toLowerCase().trim()
      );
    setTherapists(currentTherapists);
  }

  function searchbySpecialty(e) {
    const currentTherapists = allTherapists.filter(
      (therapist) =>
        therapist.specialization
          .toLowerCase()
          .trim()
          .slice(0, e.target.value.length) ===
        e.target.value.toLowerCase().trim()
    );
    setTherapists(currentTherapists);
  }

  function pickTherapist(therapistId) {
    const pickedTherapist = allTherapists.filter(
      (therapist) => therapist.id == therapistId
    )[0];
    localStorage.setItem("pickedTherapist", JSON.stringify(pickedTherapist));
    navigate("/premium");
    // navigate("/bookappointment");
    // console.log(pickedTherapist);
  }
  console.log(therapists);
  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>

      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div>
        <main className="container mx-auto p-4">
          <h1 className="text-2xl font-semibold text-center text-[#295700] mb-4">
            SEARCH DOCTORS, BOOK AN APPOINTMENT
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {/* Left Column (1/5 Width)  */}
            <div className="md:col-span-1 bg-white p-4 shadow">
              {/* Search Bar  */}
              <p className="text-green-700 text-lg mb-2">SEARCH</p>
              <input
                type="text"
                // value={name}
                className="w-full p-1 mb-4 border"
                onKeyDown={searchbyName}
                placeholder="Search By Name"
              />
              <p className="text-green-700 text-lg mb-2">DISTRICT/STATE</p>
              <input
                type="text"
                className="w-full p-1 mb-4 border"
                onChange={searchbyState}
                placeholder="Search By State..."
              />
              {/* Specialty  */}
              <div className="bg-[#D4DDCC] p-4 mt-4">
                <p className="text-[#295700] text-lg mb-2">SPECIALTY</p>
                <input
                  type="text"
                  className="w-full p-1 mb-4 border"
                  onChange={searchbySpecialty}
                  placeholder="Search By Specialty"
                />
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>Physical Abuse</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>Mental Stress</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>One-on-One Therapy</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>Anxiety</span>
                </label>
              </div>
              <br />
              <br />
              {/* Qualification  */}
              <div className="bg-[#D4DDCC] p-4 mt-4">
                <p className="text-[#295700] text-lg mb-2">QUALIFICATION</p>
                <input
                  type="text"
                  id="searchInput"
                  className="w-full p-1 mb-4 border"
                  placeholder="Search..."
                  onkeyup="searchUser()"
                />
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>MBBS (Health)</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>MBBS (Therapy)</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>MBBS (Psychology)</span>
                </label>
                <label className="inline-flex items-center space-x-2 text-[#295700]">
                  <input type="checkbox" className="form-checkbox" />
                  <span>MBBS (Oncology)</span>
                </label>
              </div>
            </div>
            {/* Right Column (4/5 Width)  */}
            <div className="md:col-span-4 bg-white p-4 shadow">
              <div className="flex flex-wrap gap-4 bg-white p-4 shadow">
                {/* {therapists && therapistSection} */}
                {therapists ? (
                  therapists?.map((therapist) => (
                    <button
                      className="flex flex-col items-center w-[15rem] flex-grow bg-[#D4DDCC] p-6 rounded-md"
                      onClick={() => pickTherapist(therapist.id)}
                    >
                      <div className="rounded-full h-32 w-32 border-4 border-[#295700] overflow-hidden">
                        <img
                          className="object-cover object-center rounded-full w-full h-full"
                          alt="image112"
                          src={
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
                          }
                        />
                      </div>
                      <p className="text-[#295700] font-semibold mt-4 text-center">
                        {therapist?.user?.firstName} {therapist?.user?.lastName}
                      </p>
                      <p className="text-[#295700] text-center">
                        {therapist.specialization}
                      </p>
                      <p className="text-[#295700] text-center">
                        {therapist.location}
                      </p>
                    </button>
                  ))
                ) : (
                  <p className="font-semibold text-xl text-[#295700]">
                    Therapists is loading. If this takes too long, please
                    refresh
                  </p>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
}

export default Maintherapy;
